interface ExplanationType {
  explanation?: Record<string, string>;
  options?: any;
  subType?: string;
  selectedOption?: string[];
  checkIcon?: boolean;
  showSingleExplanation?: boolean;
  codingExplanation?: any;
}

const ShowExplanation = ({
  explanation,
  options,
  subType,
  selectedOption,
  checkIcon = false,
  showSingleExplanation = true,
  codingExplanation
}: ExplanationType) => {

  function getExplanation(
    selectedOptions: any,
    explanation: Record<string, string>,
    allOptions: any
  ) {
    if (selectedOptions && selectedOptions.length > 0) {
      return Object.entries(explanation)?.map(([opKey, expVal], index) => {
        const val = allOptions[opKey] || "";
        if (!selectedOptions.includes(opKey)) return null;

        return (
          <div
            key={opKey || index}
            className="bg-bkg-dark dark:bg-secondary-bg font-normal p-4 text-secondary/80 break-all"
          >
            <p className="flex flex-row space-x-1">
              <span className="font-bold min-w-fit">
                {subType === "fib" ? "Blank" : "Option"} {index + 1} -
              </span>
              <span
                className="flex-1"
                dangerouslySetInnerHTML={{ __html: String(val) || "" }}
                style={{ whiteSpace: "pre-line" }}
              />
            </p>
            <p
              dangerouslySetInnerHTML={{ __html: `${expVal}` }}
              style={{ whiteSpace: "pre-line" }}
            />
          </div>
        );
      });
    }
  }

  function getExplanationForSubjective() {
    if (codingExplanation && codingExplanation?.length > 0) {
      return codingExplanation?.map((exp: any, index: number) => {
        return (
          <div
            key={index}
            className="bg-bkg-dark dark:bg-secondary-bg font-normal p-4 text-secondary/80 break-all"
          >
            <p
              dangerouslySetInnerHTML={{ __html: `${exp}` }}
              style={{ whiteSpace: "pre-line" }}
            />
          </div>
        );
      });
    }
  }

  return (
    <div
      className={`overflow-x-auto ${options && options.length > 0
        ? "bg-bkg-dark dark:bg-secondary-bg rounded-lg border border-secondary/10 border-solid"
        : ""
        }`}
    >
      <div className="max-h-[300px] overflow-y-auto thin-scrollbar">
        {codingExplanation && codingExplanation?.length > 0 ?
          getExplanationForSubjective()
          : explanation && getExplanation(selectedOption, explanation, options)}
      </div>
    </div>
  );
};

export default ShowExplanation;
